import script from "./TransactionStagesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionStagesModal.vue?vue&type=script&setup=true&lang=js"

import "./TransactionStagesModal.vue?vue&type=style&index=0&id=c7b47a6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7b47a6e"]])

export default __exports__